<template>
  <form action="" id="submitForm" method="post">
    <input type="hidden" name="verify_type" id="verify_type" value="0" />
    <div class="weui-form__control-area" style="margin-bottom: 30px">
      <h2 class="weui-form__title" style="padding: 0 32px 30px">{{loginType == 1 ? '手机号登录' : '花山账号登录'}}</h2>
      <div class="weui-cells__group weui-cells__group_form">
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label class="weui-label">{{loginType == 1 ? '手机号' : '账号'}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="tel"
                name="phone"
                maxlength="11"
                id="phone"
                :placeholder="loginType == 1 ? '请填写手机号' : '请填写账号'"
                value=""
                autofocus=""
              />
            </div>
          </div>

          <div
            class="weui-cell weui-cell_vcode"
            id="sms_code_input"
            style="display: none"
          >
            <div class="weui-cell__hd">
              <label class="weui-label">验证码</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                name="verify_code"
                value=""
                id="verify_code"
                maxlength="6"
                type="tel"
                placeholder="填写验证码"
              />
            </div>
            <div class="weui-cell__ft">
              <button
                type="button"
                class="weui-btn weui-btn_default weui-vcode-btn"
                style="cursor: pointer"
                id="send_sms"
              >
                获取验证码
              </button>
            </div>
          </div>

          <div class="weui-cell" id="password_input">
            <div class="weui-cell__hd">
              <label class="weui-label">密码</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="password"
                name="password"
                value=""
                id="password"
                placeholder="请填写密码"
              />
            </div>
          </div>
        </div>
      </div>
      <!--        <div class="switch_sms">使用短信验证码登录</div>-->
    </div>
    <div class="weui-form__opr-area" style="padding: 0 32px">
      <button
        class="weui-btn weui-btn_primary"
        type="button"
        style="width: 100%"
        @click="loginSubmit()"
        id="login"
      >
        登录
      </button>
    </div>

    <div class="wxlogin" id="wxlogin" style="display: none">
      <img src="/assets/images/wxlogin.png" width="50" />
      <p>微信登录</p>
    </div>

    <div class="weui-footer">
      <p class="weui-footer__text" id="reg_user" style="display: none">
        <a href="/#/user/register" class="weui-footer__link"
          >没有账号？点击注册&gt;&gt;</a
        >
      </p>
    </div>
  </form>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loginType: 1,
    };
  },
  methods: {
    loginSubmit() {
      layer.load();
      this.netCall("/Appapi/Login/login.html", {
          phone: $("#phone").val(),
          password: $("#password").val(),
          type: this.loginType,
        },
        function (data) {
          layer.closeAll();
          if (data.status == 1) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("userid", data.user.id);
            if (data.hstoken) {
              localStorage.setItem("hstoken", data.hstoken);
            }
            window.location.href = "/#/info/index";
          } else if (data.status == 2) {
            layer.msg(data.msg, { icon: 5 });
            window.location.href = "/#/user/verify_user?phone=" + data.phone;
          } else {
            layer.msg(data.msg, { icon: 5 });
          }
        }
      );
    },
  },
  mounted() {
    const _this = this;
    $("#submitForm").submit(function () {
      var data = $(this)
        .serializeArray()
        .reduce(function (result, item) {
          result[item.name] = item.value;
          return result;
        }, {});
      window.netApi(
        httpHost + "/Appapi/Login/login.html",
        data,
        function (data) {
          if (data.status == 1) {
            addToken(data.token);
            setCookie("user", JSON.stringify(data.user));
            window.setTimeout(function () {
              window.location.href = "/#/info/index";
            }, 2000);
          } else if (data.status == 2) {
            layer.msg(data.msg, { icon: 5 });
            window.location.href = "./verify_user.html?phone=" + data.phone;
          } else {
            layer.msg(data.msg, { icon: 5 });
          }
        }
      );
      return false;
    });
    $(".switch_sms").click(function () {
      var _this = $(this);
      if ($("#sms_code_input").is(":hidden")) {
        $("#sms_code_input").show();
        $("#password_input").hide();
        $("#verify_type").val(1);
        _this.html("使用密码登录");
      } else {
        $("#sms_code_input").hide();
        $("#password_input").show();
        $("#verify_type").val(0);
        _this.html("使用短信验证码登录");
      }
    });
    var send = true;
    $("#send_sms").click(function () {
      if (send == true) {
        send = false;
        var _this = $(this);
        var phone = $("#phone").val();
        if (phone) {
          netCall(
            httpHost + "/Home/Send/index.html",
            { phone: phone },
            function (data) {
              if (data.status == 1) {
                var _time = 120;
                var countDown = function () {
                  _this.html(_time + " s");
                  _time--;
                  if (_time <= 0) {
                    clearInterval(s);
                    _this.html("获取验证码");
                    send = true;
                  }
                };
                countDown();
                var s = setInterval(function () {
                  countDown();
                }, 1000);
              } else {
                layer.msg(data.msg);
              }
            }
          );
        } else {
          send = true;
          layer.msg("请填写手机号");
        }
      }
    });

    this.netCall("/Appapi/index/config", {}, function (data) {
      if (data.status == 1) {
        _this.loginType = data.data.websiteConfig.huashan_login == '1' ? 2 : 1;
        if (data.data.websiteConfig.minminwang_login == 1) {
          $("#wxlogin").show();
          jsBridge.wxAppInstalled(function (yes) {
            if (!yes) {
              layer.msg("未安装微信");
            }
          });
        }
        if (data.data.websiteConfig.open_register == 1) {
          $("#reg_user").show();
        }
      }
    });

    //$('#wxlogin').show();
    //jsBridge.wxAppInstalled(function (yes) {
    //if (!yes) {
    //layer.msg('未安装微信');
    //}
    //});
    // $("#wxlogin").click(function () {
    //   jsBridge.wxLogin(function (succ, obj) {
    //     if (succ) {
    //       window.netCall(
    //         httpHost + "/Appapi/Login/weixin.html",
    //         { data: JSON.stringify(obj) },
    //         function (data) {
    //           if (data.status == 1) {
    //             addToken(data.token);
    //             window.setTimeout(function () {
    //               window.location.href = "/#/info/index";
    //             }, 2000);
    //           } else {
    //             layer.msg(data.msg, { icon: 5 });
    //           }
    //         }
    //       );
    //     }
    //   });
    // });

    // $("#login").click(function () {
    //   console.log(666);
    //   _this.netCall(
    //     "/Appapi/Login/login.html",
    //     {
    //       phone: $("#phone").val(),
    //       password: $("#password").val(),
    //     },
    //     function (res) {
    //       if (res.status == 1) {
    //         localStorage.setItem("token", res.token);
    //         localStorage.setItem("userid", res.user.id);
    //         window.location.href = "/#/info/index";
    //       } else {
    //         layer.msg(res.msg);
    //       }
    //     }
    //   );
    // });
  },
};
</script>
